import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();
const collapsedTilesWithoutStorage = new Map<string, boolean>();

const storageKeyFor = (tileId: string) => `physna-dashboard-tile-collapsed:${tileId}`;

function isTileCollapsed(tileId: string): boolean {
  try {
    return localStorage.getItem(storageKeyFor(tileId)) === 'true';
  } catch {
    return collapsedTilesWithoutStorage.get(tileId) ?? false;
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function setTileCollapsed(tileId: string, isCollapsed: boolean) {
  try {
    localStorage.setItem(storageKeyFor(tileId), String(isCollapsed));
  } catch {
    collapsedTilesWithoutStorage.set(tileId, isCollapsed);
  }
  for (const listener of listeners) listener();
}

export function useTileCollapsed(tileId: string) {
  const isCollapsed = useSyncExternalStore(subscribe, () => isTileCollapsed(tileId));
  const toggleCollapsed = () => setTileCollapsed(tileId, !isCollapsed);
  return { isCollapsed, toggleCollapsed };
}
